<div class="edit-user-dialog">
  <div class="edit-user-dialog__content">
    <!-- User Info Card -->
    <div class="edit-user-dialog__user-card">
      <!-- Status Pill -->
      <div class="edit-user-dialog__status-pill" [ngClass]="statusClass">
        {{ 'settings.users.status_filter.' + data.status.toLowerCase() | translate }}
      </div>

      <!-- User Row -->
      <div class="edit-user-dialog__user-row">
        <!-- Avatar -->
        <div class="edit-user-dialog__avatar">
          <img
            [src]="data.avatar"
            [alt]="data.firstName + ' ' + data.lastName"
            (error)="onImageError($event)"
          />
        </div>

        <!-- User Info -->
        <div class="edit-user-dialog__user-info">
          <!-- Name Row -->
          <div class="edit-user-dialog__name-row">
            <!-- First Name -->
            <div class="edit-user-dialog__info-field edit-user-dialog__info-field--first-name">
              <div class="edit-user-dialog__label">
                {{ 'settings.users.edit_dialog.first_name' | translate }}
              </div>
              <div class="edit-user-dialog__value">
                {{ data.firstName }}
              </div>
            </div>

            <!-- Last Name -->
            <div class="edit-user-dialog__info-field edit-user-dialog__info-field--last-name">
              <div class="edit-user-dialog__label">
                {{ 'settings.users.edit_dialog.last_name' | translate }}
              </div>
              <div class="edit-user-dialog__value">
                {{ data.lastName }}
              </div>
            </div>
          </div>

          <!-- Email -->
          <div class="edit-user-dialog__info-field">
            <div class="edit-user-dialog__label">
              {{ 'settings.users.edit_dialog.email' | translate }}
            </div>
            <div class="edit-user-dialog__value">
              {{ data.email }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Permissions Section -->
    <div class="edit-user-dialog__permissions-section">
      <!-- User Type -->
      <div class="edit-user-dialog__permissions-column">
        <span class="edit-user-dialog__entry-label">
          {{ 'settings.users.edit_dialog.user_type' | translate }}
        </span>
        <div class="edit-user-dialog__role-options">
          <label class="edit-user-dialog__role-option">
            <input
              type="radio"
              class="edit-user-dialog__radio"
              name="userType"
              value="donor"
              [checked]="data.permissions.userType === 'donor'"
              [disabled]="isRestrictedEditor"
              (change)="onUserTypeChange('donor')"
            />
            <span class="edit-user-dialog__role-label">
              {{ 'settings.users.edit_dialog.donor' | translate }}
            </span>
          </label>
          <label class="edit-user-dialog__role-option">
            <input
              type="radio"
              class="edit-user-dialog__radio"
              name="userType"
              value="charity"
              [checked]="data.permissions.userType === 'charity'"
              [disabled]="isRestrictedEditor"
              (change)="onUserTypeChange('charity')"
            />
            <span class="edit-user-dialog__role-label">
              {{ 'settings.users.edit_dialog.charity' | translate }}
            </span>
          </label>
          <label class="edit-user-dialog__role-option">
            <input
              type="radio"
              class="edit-user-dialog__radio"
              name="userType"
              value="foundation"
              [checked]="data.permissions.userType === 'foundation'"
              [disabled]="isRestrictedEditor"
              (change)="onUserTypeChange('foundation')"
            />
            <span class="edit-user-dialog__role-label">
              {{ 'settings.users.edit_dialog.foundation' | translate }}
            </span>
          </label>
        </div>
      </div>

      <!-- User Role -->
      <div class="edit-user-dialog__permissions-column">
        <span class="edit-user-dialog__entry-label">
          {{ 'settings.users.edit_dialog.user_role' | translate }}
        </span>
        <div class="edit-user-dialog__role-options">
          @if (isRoleAvailable('normal_user')) {
            <label class="edit-user-dialog__role-option">
              <input
                type="radio"
                class="edit-user-dialog__radio"
                name="userRole"
                value="normal_user"
                [checked]="data.permissions.userRole === 'normal_user'"
                [disabled]="isRestrictedEditor"
                (change)="onUserRoleChange('normal_user')"
              />
              <span class="edit-user-dialog__role-label">
                {{ 'settings.users.edit_dialog.normal_user' | translate }}
              </span>
            </label>
          }
          @if (isRoleAvailable('charity_manager')) {
            <label class="edit-user-dialog__role-option">
              <input
                type="radio"
                class="edit-user-dialog__radio"
                name="userRole"
                value="charity_manager"
                [checked]="isCharityManagerSelected"
                [disabled]="isRestrictedEditor"
                (change)="onUserRoleChange('charity_manager')"
              />
              <span class="edit-user-dialog__role-label">
                {{ 'settings.users.edit_dialog.charity_manager' | translate }}
              </span>
            </label>
          }
          @if (isRoleAvailable('champion_admin')) {
            <label class="edit-user-dialog__role-option">
              <input
                type="radio"
                class="edit-user-dialog__radio"
                name="userRole"
                value="champion_admin"
                [checked]="data.permissions.userRole === 'champion_admin'"
                [disabled]="isRestrictedEditor"
                (change)="onUserRoleChange('champion_admin')"
              />
              <span class="edit-user-dialog__role-label">
                {{ 'settings.users.edit_dialog.champion_admin' | translate }}
              </span>
            </label>
          }
          @if (isRoleAvailable('foundation_admin')) {
            <label class="edit-user-dialog__role-option">
              <input
                type="radio"
                class="edit-user-dialog__radio"
                name="userRole"
                value="foundation_admin"
                [checked]="data.permissions.userRole === 'foundation_admin'"
                [disabled]="isRestrictedEditor"
                (change)="onUserRoleChange('foundation_admin')"
              />
              <span class="edit-user-dialog__role-label">
                {{ 'settings.users.edit_dialog.foundation_admin' | translate }}
              </span>
            </label>
          }
          @if (isRoleAvailable('super_admin')) {
            <label class="edit-user-dialog__role-option">
              <input
                type="radio"
                class="edit-user-dialog__radio"
                name="userRole"
                value="super_admin"
                [checked]="data.permissions.userRole === 'super_admin'"
                [disabled]="isRestrictedEditor"
                (change)="onUserRoleChange('super_admin')"
              />
              <span class="edit-user-dialog__role-label">
                {{ 'settings.users.edit_dialog.super_admin' | translate }}
              </span>
            </label>
          }
        </div>
      </div>

      <!-- Type -->
      @if (hasVisibleTypeFields) {
        <div class="edit-user-dialog__permissions-column">
          <span class="edit-user-dialog__entry-label">
            {{ 'settings.users.edit_dialog.type' | translate }}
          </span>
          <div class="edit-user-dialog__role-options">
            <!-- Waiting Room — temporarily hidden (see waitingRoomEnabled) -->
            @if (isTypeFieldAvailable('waitingRoom')) {
              <label class="edit-user-dialog__role-option">
                <input
                  type="checkbox"
                  class="edit-user-dialog__checkbox"
                  [checked]="data.permissions.waitingRoom"
                  [disabled]="isRestrictedEditor"
                  (change)="onPermissionTypeChange('waitingRoom', $any($event.target).checked)"
                />
                <span class="edit-user-dialog__role-label">
                  {{ 'settings.users.edit_dialog.waiting_room' | translate }}
                </span>
              </label>
            }
            @if (isTypeFieldAvailable('champion')) {
              <label class="edit-user-dialog__role-option">
                <input
                  type="checkbox"
                  class="edit-user-dialog__checkbox"
                  [checked]="data.permissions.champion"
                  [disabled]="isRestrictedEditor"
                  (change)="onPermissionTypeChange('champion', $any($event.target).checked)"
                />
                <span class="edit-user-dialog__role-label">
                  {{ 'settings.users.edit_dialog.champion' | translate }}
                </span>
              </label>
            }
            @if (isTypeFieldAvailable('languageEditor')) {
              <label class="edit-user-dialog__role-option">
                <input
                  type="checkbox"
                  class="edit-user-dialog__checkbox"
                  [checked]="data.permissions.languageEditor"
                  [disabled]="isRestrictedEditor"
                  (change)="onPermissionTypeChange('languageEditor', $any($event.target).checked)"
                />
                <span class="edit-user-dialog__role-label">
                  {{ 'settings.users.edit_dialog.language_editor' | translate }}
                </span>
              </label>
            }
          </div>
        </div>
      }
    </div>

    <!-- Charity Entries Section -->
    @if (isCharityManagerSelected) {
      <div class="edit-user-dialog__charity-entries">
        @for (entry of charityEntries; track $index; let i = $index, last = $last) {
          <div class="edit-user-dialog__entry-card">
            <div class="edit-user-dialog__entry-row">
              <div class="edit-user-dialog__entry-fields">
                <!-- Charity Name -->
                <div class="edit-user-dialog__field-group">
                  <span class="edit-user-dialog__entry-label">
                    {{ 'settings.users.edit_dialog.charity' | translate }}
                  </span>
                  <div class="edit-user-dialog__entry-input-wrapper">
                    <input
                      type="text"
                      class="edit-user-dialog__entry-input"
                      [class.edit-user-dialog__entry-input--error]="entry.showCharityError"
                      [placeholder]="'settings.users.edit_dialog.charity_placeholder' | translate"
                      [value]="entry.searchQuery"
                      [disabled]="isEntryInputDisabled(entry)"
                      [readonly]="isEntryInputDisabled(entry)"
                      (focus)="onEntryCharityFocus(i)"
                      (input)="onEntryCharityInput(i, $any($event.target).value)"
                    />
                    <svg
                      class="edit-user-dialog__entry-dropdown-arrow"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 13L16 19L22 13"
                        stroke="#a3a3a3"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div
                      class="edit-user-dialog__entry-dropdown"
                      *ngIf="entry.searchResults.length > 0"
                    >
                      <div
                        class="edit-user-dialog__entry-dropdown-item"
                        *ngFor="let result of entry.searchResults"
                        (click)="onEntryCharitySelected(i, result)"
                      >
                        {{ result.name }}
                      </div>
                    </div>
                  </div>
                  <span class="edit-user-dialog__entry-error" *ngIf="entry.showCharityError">
                    {{ 'settings.users.edit_dialog.charity_required' | translate }}
                  </span>
                </div>

                <!-- User Role -->
                <div class="edit-user-dialog__field-group">
                  <span class="edit-user-dialog__entry-label">
                    {{ 'settings.users.edit_dialog.user_role' | translate }}
                  </span>
                  <div class="edit-user-dialog__role-options">
                    <label class="edit-user-dialog__role-option">
                      <input
                        type="radio"
                        class="edit-user-dialog__radio"
                        [name]="'entryRole_' + i"
                        value="project_admin"
                        [checked]="entry.role === 'project_admin'"
                        [disabled]="isEntryRoleDisabled(entry)"
                        (change)="onEntryRoleChange(i, 'project_admin')"
                      />
                      <span class="edit-user-dialog__role-label">
                        {{ 'settings.users.edit_dialog.project_admin' | translate }}
                      </span>
                    </label>
                    <label class="edit-user-dialog__role-option">
                      <input
                        type="radio"
                        class="edit-user-dialog__radio"
                        [name]="'entryRole_' + i"
                        value="charity_admin"
                        [checked]="entry.role === 'charity_admin'"
                        [disabled]="isEntryRoleDisabled(entry)"
                        (change)="onEntryRoleChange(i, 'charity_admin')"
                      />
                      <span class="edit-user-dialog__role-label">
                        {{ 'settings.users.edit_dialog.charity_admin' | translate }}
                      </span>
                    </label>
                  </div>
                  <span class="edit-user-dialog__entry-error" *ngIf="entry.showRoleError">
                    {{ 'settings.charity_details_form.documents.error_required' | translate }}
                  </span>
                </div>

                <!-- Action Button: slot is always reserved; the button is only
                     hidden (not removed) so the layout never shifts. -->
                @if (last) {
                  <button
                    class="edit-user-dialog__entry-btn edit-user-dialog__entry-btn--add"
                    [class.edit-user-dialog__entry-btn--hidden]="!canAddMoreCharityEntries"
                    type="button"
                    (click)="addCharityEntry()"
                    [disabled]="!canAddMoreCharityEntries"
                    aria-label="Add charity"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 1V13M1 7H13"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                } @else {
                  <button
                    class="edit-user-dialog__entry-btn edit-user-dialog__entry-btn--delete"
                    [class.edit-user-dialog__entry-btn--hidden]="isEntryLocked(entry)"
                    type="button"
                    (click)="deleteCharityEntry(i)"
                    [disabled]="isEntryLocked(entry)"
                    aria-label="Delete charity"
                  >
                    <svg
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.5 3H2.54762H10.5"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.11914 3V1.95238C4.11914 1.69944 4.21962 1.45678 4.39894 1.27746C4.57826 1.09814 4.82092 0.997656 5.07386 0.997656H6.93672C7.18966 0.997656 7.43232 1.09814 7.61164 1.27746C7.79096 1.45678 7.89144 1.69944 7.89144 1.95238V3M9.46191 3V10.0476C9.46191 10.3006 9.36143 10.5432 9.18211 10.7225C9.00279 10.9019 8.76013 11.0024 8.50719 11.0024H3.50291C3.24997 11.0024 3.00731 10.9019 2.82799 10.7225C2.64867 10.5432 2.54819 10.3006 2.54819 10.0476V3H9.46191Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.07227 5.33594V8.57689"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.92969 5.33594V8.57689"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Action Buttons -->
    <div class="edit-user-dialog__actions">
      @if (isElevatedAdmin) {
        <button
          type="button"
          class="edit-user-dialog__button edit-user-dialog__button--gray"
          (click)="onResetPassword()"
          [disabled]="isResettingPassword"
        >
          {{
            isResettingPassword
              ? ('common.loading' | translate)
              : ('settings.users.edit_dialog.reset_password' | translate)
          }}
        </button>
        <button
          type="button"
          class="edit-user-dialog__button edit-user-dialog__button--gray"
          (click)="onEditUserProfile()"
        >
          {{ 'settings.users.edit_dialog.edit_user_profile' | translate }}
        </button>
      }
      <button
        type="button"
        class="edit-user-dialog__button edit-user-dialog__button--yellow"
        (click)="onSave()"
        [disabled]="isSaving"
      >
        {{
          isSaving
            ? ('common.loading' | translate)
            : ('settings.users.edit_dialog.save' | translate)
        }}
      </button>
    </div>
  </div>

  <!-- Close Button -->
  <button
    type="button"
    class="edit-user-dialog__close-btn"
    (click)="onClose()"
    aria-label="Close"
    cdkFocusInitial
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B" />
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</div>
